(function(){
var searchbycar = {
  createCpokie:function (key, value,exdays) {
    expires = new Date();
    expires.setTime(expires.getTime()+ (exdays*24*60*60*1000));cookie = key + '=' + value + ';expires=' + expires.toUTCString()+';path=/';
    return document.cookie = cookie;
  },
  readCookie:function (key) {
    keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    if (keyValue) {
      return keyValue[2];
    }else{
      return 'empty';
    }
  },
  setCookie:function (cname,cvalue,exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = 'expires=' + d.toGMTString();document.cookie = cname+'='+cvalue+'; '+expires+';path=/';
  },
  deleteCookie:function(cname){
    expires = new Date();expires.setTime(expires.getTime()+ (-1*24*60*60*1000));
    cookie = cname + '=;expires='+expires.toUTCString()+';path=/';
    return document.cookie = cookie;
  },
  get:function(v,data,$){
    var arr = {shop:Shopify.shop,q:v.value,parent:v.parent,option_sort:v.option_sort,index:v.index,format:'json',sbcdata:searchbycar.readCookie('sbc-load-data')};
    $.ajax({
      type: 'GET',
      dataType: 'jsonp',
      async: true,
      data: arr,
      url: '//api-searchbycar.apolomultimedia-server3.info/api/shopify/searchv3',
      contentType: 'application/json',
      success: function(json) {
        searchbycar.content(arr.index,data,json,$);
      },
      error: function(xhr) { // if error occured
        //
      },
      complete: function() {
        searchbycar.select(data,$);
        searchbycar.buttonSearch(data,$);
      }
    });
  },
  getId:function(v,data,$){
    var arr = {shop:Shopify.shop,q:v.value,parent:v.parent,option_sort:v.option_sort,index:v.index,format:'json',sbcdata:'empty'};
    $.ajax({
      type: 'GET',
      dataType: 'jsonp',
      async: true,
      data: arr,
      url: '//api-searchbycar.apolomultimedia-server3.info/api/shopify/searchv3',
      contentType: 'application/json',
      success: function(json) {
        searchbycar.contentId(arr.index,data,json,$);
      },
      error: function(xhr) { // if error occured
        //
      },
      complete: function() {
        searchbycar.select(data,$);
        searchbycar.buttonSearch(data,$);
      }
    });
  },
  content:function(index,data,json,$){
      var arr = [],prefix = '',textLoadData = '',textPrefix = '',textParent = '',textParentPrefix = '',num=0,x=-1;
      if(index == -1)
      {
        index = index + 1;
      }
      if(json.prefixId)
      {
      	textParentPrefix = '<option value="" selected="selected" disabled="disabled">'+json.prefixId.title+'</option>';
      }
      if(json.parent)
      {
        $.each(json.parent, function( index, value ) {
          textParent = textParent.concat('<option value="'+value.option_url+'" data-handle="'+value.option_sort+'">'+value.option_title+'</option>');
        });
      }
      if(json.prefix)
      {
        $.each(json.prefix, function( index, value ) {
          textPrefix = textPrefix.concat('<select class="prefix-'+value.id+' sbc-index-'+index+'" data-index="'+index+'" disabled="disabled"><option value="" selected="selected" disabled="disabled">'+value.title+'</option></select>');
        });
      }

      $('.sb-car-shopify').html('<div class="sb-car-content"><h1 class="sb-vehicle">'+data.titlecontent+'</h1><div class="sbc-content-select">'+textPrefix+'</div><a href="javascript:void(0);" class="btn-sbc">Search</a></div>');
    
      $('.sbc-index-'+index).html(textParentPrefix+textParent);
      
      $('.sbc-index-'+index).removeAttr('disabled');
    
    if(!textParent)
    {
      return false;
    }
     if(json.sbcdata != false)
     {
       num = json.sbcdata.length - 1;
       $.each(json.sbcdata, function( index, value ) {
         x = x + 1;
         textLoadData = '';
         if(value.data != null)
         {
           if(value.prefix != null)
           {
           	prefix = '<option value="" selected="selected" disabled="disabled">'+value.prefix.title+'</option>';
           }
           $.each(value.data, function( z, w ) {
             textLoadData = textLoadData.concat('<option value="'+w.option_url+'" data-handle="'+w.option_sort+'">'+w.option_title+'</option>');
           });
           textLoadData = prefix+textLoadData;
         }
         if(value.prefix != null)
         {
           $('.prefix-'+value.prefix.id).removeAttr('disabled');
           $('.prefix-'+value.prefix.id).html(textLoadData);
         }
         $('.sbc-index-'+x).val(value.id);
         if(x == num)
         {
           setTimeout(function(){ $('.sbc-index-'+x).change().val(value.id); }, 500);
         }
       });
     }
  },
  contentId:function(index,data,json,$){
      var textParentId = '',textParentPrefix = '',position = '',first_option='';
      index = index + 1;
      if(json.prefixId != null)
      {
        position = parseInt(json.prefixId.sort) - 1;
      	textParentPrefix = '<option value="" selected="selected" disabled="disabled">'+json.prefixId.title+'</option>';
      }
      if(json.parentId != null)
      {
        $.each(json.parentId, function( index, value ) {
          textParentId = textParentId.concat('<option value="'+value.option_url+'" data-handle="'+value.option_sort+'">'+value.option_title+'</option>');
        });
        if($('.sbc-index-'+index).length > 0)
        {
          $('.sbc-index-'+index).html(textParentPrefix+textParentId);
          $('.sbc-index-'+index).removeAttr('disabled');
        }
      }
      $('.sbc-content-select').find('select').each(function( index ) {
        if(position !== '')
        {
          if(index > position)
          {
            first_option = $('.sbc-index-'+index).find('option:first');
            first_option = first_option.removeAttr('disabled');
            $('.sbc-index-'+index).attr('disabled','disabled');
            $('.sbc-index-'+index).find('option').remove();
            $('.sbc-index-'+index).html(first_option);
          }
        }
      });
  },
  select:function(data,$){
    $('.sb-car-content').find('select').unbind('change');
    $('.sb-car-content').find('select').change(function(e){
      e.preventDefault();
      var text= '',value = 1,parent = $(this).val(),option_sort = $(this).data('index'), i = $(this).data('index');
      option_sort = option_sort + 1;
      parent = parent+'|';
      $('.sbc-content-select').find('select').each(function( index ) {
        var handle = $(this).val();
        if(handle !== '')
        {
          if(handle != null)
          {
            if (typeof handle !== "undefined") {
              if(index <= i)
              {
          		text = text.concat(handle+'|');
              }
            }
          }
        }
      });
      value = { value: value,option_sort:option_sort, index: i,parent:text };
      searchbycar.getId(value,data,$);
    });
  },
  buttonSearch:function(data,$){
    var text = '',textIds = '',texthandle = '';
    $('.sb-car-content a.btn-sbc').unbind('click');
    $('.sb-car-content a.btn-sbc').click(function(e){
      e.preventDefault();
      text = '',texthandle = '';
      $('.sb-car-content .sbc-content-select').find('select').each(function( index ) {
        var value = $(this).val();
        if(value !== '')
        {
          if(value != null)
          {
            if (typeof value !== "undefined") {
              text = text.concat($(this).val()+'-');
              texthandle = texthandle.concat($(this).val()+'|');
            }
          }
        }
      });
      if(text !== '')
      {
        text = text.slice(0, -1);
        searchbycar.createCpokie('sbc-load-data',texthandle,1);
        window.location.href = '/search?q='+text+'*&type=product';
      }
    });
  },
  writeStyles:function(styleName, cssText) {
    var styleElement = document.getElementById(styleName);
    if (styleElement) 
    document.getElementsByTagName('head')[0].removeChild(
    styleElement);
    styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.id = styleName;
    styleElement.innerHTML = cssText;
    document.getElementsByTagName('head')[0].appendChild(styleElement);
  },
  addStyle:function(data,$){
    var w = '',width_box = 'inherit',select_width_options = '180px',display_option='inline-block',display_margin = '10px';
    if(data.boxorientation == 1)
    {
      w = 'width:100%;';
      width_box = '300px';
      select_width_options = '100%';
      display_option = 'block';
      display_margin = '0px';
    }
    var cssText = '@import url(http://fonts.googleapis.com/css?family='+data.titlefontfamily+');@import url(http://fonts.googleapis.com/css?family='+data.optionfontfamily+');@import url(http://fonts.googleapis.com/css?family='+data.buttonfontfamily+');.sbc-content-select{display: '+display_option+';}.sb-car-shopify .sb-car-content h1.sb-vehicle{color:'+data.titlefontcolor+';font-family: '+data.titlefontfamily+';font-style: '+data.titlefontstyle+';font-size:'+data.titlefontsize+';font-weight:'+data.titlefontweight+'}.sb-car-shopify .sb-car-content{background: '+data.boxbackground+';border-color: '+data.boxbordercolor+';border-width: '+data.boxborderwidth+';border-style: '+data.boxborderstyle+';border-radius:'+data.boxborderradius+';max-width:'+width_box+';'+w+'}.sb-car-shopify .sb-car-content a.btn-sbc{background: '+data.buttonbackground+';border-color: '+data.buttonbordercolor+';border-radius:'+data.buttonborderradius+';border-style:'+data.buttonborderstyle+';border-width:'+data.buttonborderwidth+';color:'+data.buttoncolor+'; font-style:'+data.buttonfontstyle+';font-family: '+data.buttonfontfamily+';font-size:'+data.buttonfontsize+';}.sb-car-shopify .sb-car-content a.btn-sbc:hover{background: '+data.buttonhoverbackground+';color:'+data.buttonhovercolor+';}.sb-car-shopify .sb-car-content select{ border-radius: '+data.optionborderradius+';color: '+data.optionfontcolor+';font-style:'+data.optionfontstyle+';font-family: '+data.optionfontfamily+';display: '+display_option+';width: '+select_width_options+';margin-right:'+display_margin+';font-size:'+data.optionfontsize+';}@media screen and (max-width: 768px) {.sb-car-shopify .sb-car-content select {width: 100%;}}';
    searchbycar.writeStyles('styles_js', cssText);
    $('head').append(data.picker_style_button+data.picker_style_options+data.style);
  },
  init: function(data,$){
    var q = {value:'',parent:'',option_sort:'',index:-1};
    if(data.status > 0)
    {
    	this.addStyle(data,$);
		this.get(q,data,$);
    }
  }
}
var loadScript = function(url, callback){
  var script = document.createElement("script");
  script.type = "text/javascript";
  // If the browser is Internet Explorer.
  if (script.readyState){ 
    script.onreadystatechange = function(){
      if (script.readyState == "loaded" || script.readyState == "complete"){
        script.onreadystatechange = null;
        callback();
      }
    };
    // For any other browser.
  } else {
    script.onload = function(){
      callback();
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
};
var loadScripts = function($,scripts, callback) {
  var deferred = $.Deferred();
  function loadScript(scripts, callback, i) {
    $.ajax({
      url: scripts[i],
      dataType: "script",
      cache: true,
      success: function() {
        if (i + 1 < scripts.length) {
          loadScript(scripts, callback, i + 1);
        } else {
          if (callback) {
            callback();
          }
          deferred.resolve();
        }
      }
    });
  }
  loadScript(scripts, callback, 0);
  return deferred;
}
var jsonp = function(url, callback){
  var callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
  window[callbackName] = function(data) {
    delete window[callbackName];
    document.body.removeChild(script);
    callback(data);
  };
  var script = document.createElement('script');
  script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName;
  document.body.appendChild(script);
}
function loadScript2(url, callback, data){
  var script = document.createElement("script")
  script.type = "text/javascript";
  if (script.readyState){  //IE
    script.onreadystatechange = function(){
      if (script.readyState == "loaded" ||
          script.readyState == "complete"){
        script.onreadystatechange = null;
        callback(data);
      }
    };
  } else {  //Others
    script.onload = function(){
      callback(data);
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}
var myAppJavaScript = function($){
  var d = new Date();
  var n = d.getTime();
  $('head').append('<link rel="stylesheet" href="https://api-searchbycar.apolomultimedia-server3.info/assets/css/searchbycar.css?'+n+'" type="text/css" />');
  jsonp('https://api-searchbycar.apolomultimedia-server3.info/api/shopify/call?shop='+Shopify.shop+'&format=json', function(data) {
    searchbycar.init(data,$);
  });
};
if ((typeof jQuery === 'undefined') || (parseInt(jQuery.fn.jquery) === 1 && parseFloat(jQuery.fn.jquery.replace(/^1\./,"")) < 9.1)) {
  loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
    jQuery191 = jQuery.noConflict(false);
    myAppJavaScript(jQuery191);
  });
} else {
  myAppJavaScript(jQuery);
}

})();